// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RB-st","question":"styles_question__1Mnen","description":"styles_description__3qDIf"};